export const CAREERS_EMAIL = 'walkitoffhealth@gmail.com';

export const ROLES = [
  {
    id: 'social-media-content-lead',
    title: 'Social Media & Content Lead',
    meta: ['Full-time', 'Remote'],
    summary: [
      "We're looking for a Social Media & Content Lead to turn Walk It Off's TikTok, Instagram and YouTube into a growth engine: the creative direction, the content, the formats, the testing, and the numbers that tie views to users.",
      "This is a hands-on, builder role, not a \"manage an agency and approve posts\" job. You'll set the creative direction and still cut the edit yourself when a trend breaks at midnight."
    ],
    responsibilities: [
      'Own TikTok, Instagram Reels and YouTube Shorts end to end: strategy, content calendar, publishing, community and analytics',
      'Own creative direction. Define how Walk It Off looks, sounds and feels on social, and hold the bar on everything we publish',
      'Make the content yourself: script, shoot, edit and design, shipping daily in CapCut, Premiere, After Effects, Figma or equivalent',
      "Run a fast, systematic testing program across hooks, formats and series. Kill what doesn't work, scale what does",
      'Build the measurement that connects views to waitlist signups, installs and active walkers, not just followers',
      "Build brand formats that work faceless or on camera, and step in front of the camera when it's the right call",
      'Spot trends early, run a creator, UGC and clipping bench, and turn walking, fitness and health culture moments into content within hours',
      'Make sure everything we publish is accurate and responsible. We talk to people managing diabetes, prediabetes and heart health, so no medical claims and no hype'
    ],
    requirements: [
      'A proven track record taking a page from 0 to 1: you built its first real audience',
      'A proven track record taking a page from 1 to 100: you grew an established account to a much larger audience and kept engagement healthy',
      'Ownership of creative direction: a brand look, a recurring series or campaigns where the calls were yours',
      'Hands-on editing and graphic design skills, with a reel of work you cut and designed yourself',
      'Experience growing social for a consumer mobile app, where the goal was downloads and active users. Health, fitness or wellness experience is a strong plus',
      'Experience scaling brand pages, faceless or on camera, not just a personal account',
      "A scrappy, high-energy operator mindset. You thrive in a fast-paced, resource-lean environment where you're building the playbook as you go"
    ],
    milestones: [
      ['First 30 days', 'Channel audit done, creative direction agreed, daily posting live on all three platforms'],
      ['First 90 days', '3+ repeatable formats proven by testing, first post past 1M views, views-to-signup tracking in place'],
      ['First 180 days', 'Social is a measurable top-3 acquisition channel, with follower and view growth compounding month on month']
    ],
    apply:
      "Send your résumé, links to the pages you grew with before-and-after numbers, and the 3 posts you're proudest of, with a line on why each worked.",
    closer: "If you'd rather ship the post than write the deck about it, this is your role."
  }
];
